import React, { useEffect, useState } from 'react'

const DataHeader = (props) => {
    const { coltype, columns, changeSort, sort_by, headerGroups, ...rest } = props
    const [sorted, setSorted] = useState("")
    const [direction, setDirection] = useState("asc")

    useEffect(() => {
        if (sorted !== "" && direction !== "") {
            changeSort(sorted + " " + direction)
        }
    }, [sorted, direction])

    const sortData = (col) => {
        if (col === sorted) {
            if (direction === "asc") {
                setDirection("desc")
            } else {
                setDirection("asc")
            }
        } else {
            setDirection("asc")
            setSorted(col)
        }
    }

    const sortHeader = (col, extraStyle = {}) => (
        <th key={col}
            style={sort_by.includes(col) ?
                {
                    textAlign: "center",
                    verticalAlign: "middle",
                    width: coltype[col].width ? coltype[col].width + "px" : "auto",
                    ...extraStyle
                }
                : {
                    textAlign: "center",
                    paddingRight: "7px",
                    verticalAlign: "middle",
                    width: coltype[col].width ? coltype[col].width + "px" : "auto",
                    ...extraStyle
                }
            }
            className={sort_by.includes(col) ? col === sorted ? "sorting sorting_" + direction : "sorting" : "nosort"}
            onClick={sort_by.includes(col) ? () => sortData(col) : (field) => { }}
        >
            {coltype[col].headerLabel || coltype[col].label}
        </th>
    )

    const normalizedGroups = Array.isArray(headerGroups) ? headerGroups : []
    const groupedColumns = new Set(normalizedGroups.flatMap((group) => group?.columns || []))

    if (normalizedGroups.length > 0) {
        return (
            <>
                <tr>
                    {columns && columns.map((col) => {
                        if (!(col in coltype)) {
                            return null
                        }
                        const group = normalizedGroups.find((item) => (item?.columns || [])[0] === col)
                        if (group) {
                            const visibleColumns = (group.columns || []).filter((item) => columns.includes(item) && item in coltype)
                            return (
                                <th key={group.label}
                                    colSpan={visibleColumns.length}
                                    style={{ textAlign: "center", verticalAlign: "middle" }}
                                    className="nosort"
                                >
                                    {group.label}
                                </th>
                            )
                        }
                        if (groupedColumns.has(col)) {
                            return null
                        }
                        return (
                            <th key={col}
                                rowSpan={2}
                                style={{
                                    textAlign: "center",
                                    paddingRight: "7px",
                                    verticalAlign: "middle",
                                    width: coltype[col].width ? coltype[col].width + "px" : "auto"
                                }}
                                className={sort_by.includes(col) ? col === sorted ? "sorting sorting_" + direction : "sorting" : "nosort"}
                                onClick={sort_by.includes(col) ? () => sortData(col) : (field) => { }}
                            >
                                {coltype[col].label}
                            </th>
                        )
                    })}
                </tr>
                <tr>
                    {columns && columns.map((col) =>
                        col in coltype && groupedColumns.has(col) && sortHeader(col)
                    )}
                </tr>
            </>
        )
    }

    return (
        <tr>
            {columns && columns.map((col) =>
                col in coltype &&
                sortHeader(col)
            )}
        </tr>
    )
}

DataHeader.defaultProps = {
    columns: null,
    coltype: null,
    headerGroups: null,
    sort_by: [],
    changeSort: (sortfield) => { }
}

export default DataHeader
